import { z } from "zod"

export const UpdateProductionSiteFieldDefinitionSchema = z
  .object({
    title: z.string(),
    type: z.enum(["STRING", "NUMBER", "SELECT", "STANDARD", "MULTI_SELECT"]),
    forActivities: z.array(z.string()),
    min: z.number().optional(),
    max: z.number().optional(),
    enumValues: z.array(z.string()),
    enabledForClients: z.array(z.uuid()),
  })
  .refine((data) => {
    if (data.type === "SELECT" || data.type === "MULTI_SELECT") {
      return data.enumValues.length > 1
    }
    return true
  })

export type UpdateProductionSiteFieldDefinition = z.infer<
  typeof UpdateProductionSiteFieldDefinitionSchema
>

export const UpdateProductionSiteFieldDefinitionParamsSchema = z.object({
  id: z.string(),
})

export type UpdateProductionSiteFieldDefinitionParams = z.infer<
  typeof UpdateProductionSiteFieldDefinitionParamsSchema
>
